<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { PackageSlider, BaseIcon, CardItem } from "@/components";
import { getBreadCrumbs } from "../utils/breadcrumb";
import { getItem } from "../utils/tokenTools";
import mixins from "../mixins/index";

export default {
  name: "BuyDataPackage",
  components: {
    PackageSlider,
    BaseIcon,
    CardItem,
  },
  mixins: [mixins],
  props: {
    memberType: {
      type: Number,
    },
  },
  data() {
    return {
      recommendedPackages: null,
      currentTab: 1,
      profCurrentTab: null,
      algoCurrentTab: null,
      featureTypeId: null,
      esube: getItem("esube"),
      cusId: null,
      overallLimit: 0,
      getActiveProductsLength: 0,
      isAppsResponseReturned: false,
      researchListState: [],
    };
  },
  computed: {
    ...mapGetters([
      "getRecommendedPackages",
      "customer",
      "apps",
      "allResearch",
      "profAlgoApps",
      "appsTab",
      "profAlgoTab",
      "allPackages",
    ]),
    customerId() {
      return this.$route.params.customerNumber;
    },
  },
  methods: {
    ...mapActions([
      "getRecommendedPackageList",
      "searchCustomer",
      "getApps",
      "getAllResearch",
      "getProfAlgoApps",
      "getAppsTab",
      "getProfAlgoTab",
      "getMember",
      "getAllPackages",
      "monthlyGetOverallLimit",
    ]),
    ...mapMutations(["setProfAlgoApps", "setUserInfo"]),
    tabClass(id, name = "tab", place = this.currentTab) {
      return [{ active: place === id }, name];
    },
    errorMessage(response) {
      if (response?.data?.error === true) {
        return this.$toast.error(response.data.message);
      }
    },
    goBack() {
      const goBack =
        this.esube == "yes"
          ? this.$router.go(-1)
          : this.$router.push({
              name: this.$route?.meta?.breadcrumb[1].url.name,
              params: this.$route?.meta?.breadcrumb[1].url.params,
            });
      return goBack;
    },
    changeTab(id, featureTypeId) {
      this.featureTypeId = featureTypeId;
      this.currentTab = id;
      this.setProfAlgoApps([]);

      const professionalScreen = 2;
      const algoScreen = 3;
      const researchScreen = 4;

      if (id === professionalScreen) {
        this.getProfAlgoTab(professionalScreen).then((res) => {
          if (res) {
            this.profCurrentTab = this.profAlgoTab[0].id;
            this.getProfAlgoApps([
              this.profCurrentTab,
              this.featureTypeId,
              this.cusId,
            ]).then((response) => {
              this.errorMessage(response);
            });
          }
        });
      } else if (id === algoScreen) {
        this.getProfAlgoTab(algoScreen).then((res) => {
          if (res) {
            this.algoCurrentTab = this.profAlgoTab[0].id;
            this.getProfAlgoApps([
              this.algoCurrentTab,
              this.featureTypeId,
              this.cusId,
            ]).then((response) => {
              const terminalAlgoName = "MATRİKS - Oto Al-Sat - Terminal";
              const otoAlSatAlgoName = "MATRİKS - Oto Al-Sat";
              const idealTerminalName = "İDEAL - Robot Yetkisi - Terminal";
              const idealName = "İDEAL - Robot Yetkisi";

              const nextAlgoApps = (this.profAlgoApps || []).filter((app) => {
                const algoName = app?.algorithm?.name;
                if (this.esube === "no")
                  return algoName !== otoAlSatAlgoName && algoName !== idealName;
                if (this.esube === "yes")
                  return (
                    algoName !== terminalAlgoName && algoName !== idealTerminalName
                  );
                return true;
              });

              this.setProfAlgoApps(nextAlgoApps);
              this.errorMessage(response);
            });
          }
        });
      } else if (id === researchScreen) {
        if (this.$route.query.isRecommended != undefined) {
          this.getAllResearch().then((response) => {
            this.errorMessage(response);
            this.researchListState = this.allResearch;
            this.researchListState = this.researchListState.filter(
              (o) => o.id == 6406
            );
          });
        } else {
          this.getAllResearch().then((response) => {
            this.errorMessage(response);
            this.researchListState = this.allResearch;
          });
        }

        return;
      }
    },
    changeSubTab(id, name) {
      this[name] = id;
      this.getProfAlgoApps([id, this.featureTypeId, this.cusId]).then(
        (response) => {
          const terminalAlgoName = "MATRİKS - Oto Al-Sat - Terminal";
          const otoAlSatAlgoName = "MATRİKS - Oto Al-Sat";
          const idealTerminalName = "İDEAL - Robot Yetkisi - Terminal";
          const idealName = "İDEAL - Robot Yetkisi";
          const list = Array.isArray(response?.data) ? response.data : [];

          const nextAlgoApps = list.filter((app) => {
            const algoName = app?.algorithm?.name;
            if (this.esube === "no")
              return algoName !== otoAlSatAlgoName && algoName !== idealName;
            if (this.esube === "yes")
              return (
                algoName !== terminalAlgoName && algoName !== idealTerminalName
              );
            return true;
          });

          this.setProfAlgoApps(nextAlgoApps);
          this.errorMessage(response);
        }
      );
    },
    getRecommendedData() {
      this.getRecommendedPackageList(this.cusId).then((res) => {
        if (res) {
          this.recommendedPackages = this.getRecommendedPackages;
        }
      });
    },

    getCustomer() {
      this.searchCustomer({
        customerNo: this.customerId,
        cusId: this.cusId,
      }).then((res) => {
        if (res && this.$route.query.isRecommended === undefined) {
          getBreadCrumbs({
            breadcrumbs: ["CustomerDetail", "BuyDataPackage"],
            customer: this.customer,
            customerDetail: this.customerId,
            buyDataPackage: this.customerId,
            cusId: this.cusId,
          });
        }
      });
    },
    getOverallLimitOnLoad() {
      this.monthlyGetOverallLimit().then((response) => {
        if (response.status === 200) {
          this.overallLimit = response.data.overallLimit;
        }
      });
    },
  },
  mounted() {
    if (this.$route.query.isRecommended === undefined) {
      this.cusId = this.$route.query.c;
    } else {
      this.cusId = localStorage.getItem("userId");
    }
    this.getAllPackages(this.cusId);
    this.$nextTick(() => {
      setTimeout(() => {
        const getActives = this.allPackages.data.filter(
          (o) => o.packageStatus.id == 2
        );
        this.getActiveProductsLength = getActives.length;
      }, 250);
    });
    if (this.memberType) {
      if (this.cusId) {
        let userIdAsNumber = parseInt(this.cusId);
        let payload = {
          id: userIdAsNumber,
        };
        this.getMember(payload).then((response) => {
          this.setUserInfo({
            ...response.data,
            memberType: this.memberType,
          });
        });
      }
    }
    this.getRecommendedData();
    if (this.esube != "yes") {
      this.getCustomer();
    }
    this.getApps(1);
    this.getAppsTab().then((response) => {
      this.errorMessage(response);
      if (response) {
        this.isAppsResponseReturned = true;
      }
    });
    this.getOverallLimitOnLoad();
  },
};
</script>
<template>
  <div class="customer-detail" :class="esube == 'yes' ? 'mt-20' : ''">
    <div
      class="buy-package custom-container"
      :class="esube == 'yes' ? 'p-0' : ''"
    >
      <div class="backward" v-if="$route.query.isRecommended === undefined">
        <button @click="goBack" class="back-button">
          <base-icon name="controls-backward" />Geri dön
        </button>
      </div>

      <div class="tab-layout">
        <div class="tabs custom-container" v-if="isAppsResponseReturned">
          <div
            :key="tab.id"
            v-for="tab in appsTab"
            :class="tabClass(tab.id, 'tab', currentTab)"
            :id="'tab-' + tab.id"
          >
            <div
              @click="changeTab(tab.id, tab.featureTypeId)"
              v-if="
                (tab.id == 1 || tab.id == 2 || tab.id == 4) &&
                $route.name == 'BuyRecomendedPackage'
              "
            >
              <h6>{{ tab.name }}</h6>
            </div>
            <div
              @click="changeTab(tab.id, tab.featureTypeId)"
              v-else-if="$route.name != 'BuyRecomendedPackage'"
            >
              <h6>{{ tab.name }}</h6>
            </div>
          </div>
        </div>
        <div
          class="slider"
          v-if="
            this.$route.name != 'BuyRecomendedPackage' &&
            recommendedPackages &&
            currentTab != 1
          "
        >
          <package-slider
            :packages="recommendedPackages"
            :isDisplay="true"
          ></package-slider>
          <!-- :isDisplay="getActiveProductsLength == 0 ? true : false" -->
        </div>
        <div class="tab-content buy-package__content">
          <div v-if="currentTab === 1" id="osmanli">
            <div class="tab-item">
              <div class="message">
                <h6 class="message-title">
                  Almak istediğiniz uygulama tipini seçiniz.
                </h6>
              </div>
              <div class="info">
                <base-icon name="warn-yellow"></base-icon>
                <p>
                  Portföy büyüklüğü
                  {{ formatPriceNoDecimal(overallLimit) }}&nbsp;TL ve üzeri olan
                  yatırımcılarımız, Osmanlı uygulamalarından karma lisansı
                  ücretsiz alabilirler.
                  {{ formatPriceNoDecimal(overallLimit) }}&nbsp;TL portföy
                  büyüklüğüne BES sözleşmeleriniz de dahil edilmektedir.
                </p>
              </div>
              <div class="card-container package-list">
                <card-item
                  :cssClass="'package-card'"
                  :key="d + Math.random()"
                  v-for="d in apps"
                  :item="{
                    imageUrl: d.imageUrl,
                    title: d.name,
                    subtitle: d.shortContent,
                    description: d.description,
                    price: d.price,
                    ...d,
                  }"
                ></card-item>
              </div>
            </div>
          </div>
          <div v-if="currentTab === 2" id="professional">
            <div class="profAlgoTabs">
              <div
                @click="changeSubTab(item.id, 'profCurrentTab')"
                :class="tabClass(item.id, 'profAlgoTab', profCurrentTab)"
                :key="item.id"
                v-for="item in profAlgoTab"
                :id="'profTabs-' + item.id"
              >
                <p class="name">{{ item.name }}</p>
              </div>
            </div>
            <div class="warn-text">
              Almak istediğiniz uygulama tipini seçiniz.
            </div>
            <div class="info">
              <base-icon name="warn-yellow"></base-icon>
              <p>
                Satın alınan ekran için gerekli koşulların sağlanması halinde
                ücret kesintisi yapılmayacaktır.
              </p>
            </div>
            <div class="card-container package-list">
              <div class="info" v-if="this.profAlgoApps.filter((i) => (i.applicationId == 4)).length">
                <base-icon name="warn-yellow"></base-icon>
                <p>
                  Matriks Mobil veya Matriks geçişli ürünlerine "Osmanlı Pro" lisansı tanımlayarak Matriks Mobil uygulaması üzerinden E-şube'deki birçok menüye üzerinden kolay ve hızlıca ulaşabilirsiniz.
                </p>
              </div>
              <div class="info" v-if="this.profAlgoApps.filter((i) => (i.applicationId == 5)).length">
                <base-icon name="warn-yellow"></base-icon>
                <p>
                  Matriks IQ ürünlerine "Osmanlı Pro" lisansı tanımlayarak Matriks IQ Masaüstü ve Mobil platformları üzerinden E-şube'deki birçok menüye üzerinden kolay ve hızlıca ulaşabilirsiniz.
                </p>
              </div>
           
              <card-item
                :key="d.name + Math.random()"
                v-for="d in this.profAlgoApps"
                :item="{
                  imageUrl: d.imageUrl,
                  title: d.name,
                  subtitle: d.platform && d.platform.name,
                  description: d.description,
                  price: d.price,
                  ...d,
                }"
              ></card-item>
            </div>
          </div>
          <div v-if="currentTab === 3" id="algoServer">
            <div class="profAlgoTabs">
              <div
                @click="changeSubTab(item.id, 'algoCurrentTab')"
                :class="tabClass(item.id, 'profAlgoTab', algoCurrentTab)"
                :key="item.id"
                v-for="item in profAlgoTab"
                :id="'algoTabs-' + item.id"
              >
                <p class="name">{{ item.name }}</p>
              </div>
            </div>

            <div
              class="card-container package-list"
              :class="profAlgoApps.length > 3 ? 'bigger-package' : ''"
            >
              <card-item
                :key="d.name + Math.random()"
                v-for="d in this.profAlgoApps"
                :item="{
                  imageUrl: d.imageUrl,
                  title: d.name,
                  subtitle: d.algorithm && d.algorithm.name,
                  description: d.description,
                  price: d.price,
                  ...d,
                }"
                :currentTab="'Algo'"
              ></card-item>
            </div>
          </div>
          <div v-if="currentTab === 4" id="research">
            <div
              class="card-container package-list"
              :class="researchListState.length > 3 ? 'bigger-package' : ''"
            >
              <card-item
                :key="d.name + Math.random()"
                v-for="d in this.researchListState"
                :item="{
                  imageUrl: d.imageUrl,
                  title: d.name,
                  subtitle: d.application && d.application.name,
                  description: d.description,
                  price: d.price,
                  ...d,
                }"
                :currentTab="'Research'"
              ></card-item>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
@media (max-width: 610px) {
  .card-container {
    &.package-list {
      .card {
        margin-bottom: 0px;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.osm-vd[memberType="true"] .customer-detail {
  margin-top: 20px;
}
.alert-text {
  font-size: 18px !important;
  background: red;
  color: white;
  padding: 10px !important;
}
.backward {
  background: #fff;
  .back-button {
    border: none;
    background-color: transparent;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px 20px 14px 20px;
    @media (max-width: 768px) {
      padding: 16px 20px 14px 5px;
    }
  }
}

.card-container {
  position: relative;
  display: flex !important;
  flex-wrap: wrap !important;
  gap: 30px !important;
}

.burger-menu {
  position: relative;
  display: none;
  @media (max-width: 544px) {
    padding: 20px 0;
    display: block;
  }
  .menu-icon {
    width: 35px;
  }
  .menu-container {
    background-color: var(--grayscale-0);
    border-radius: var(--radius-second);
    border: solid 1px var(--grayscale-20);
    font-size: 16px;
    padding: 10px;
    li {
      display: block;
      margin-bottom: 10px;
      padding: 5px 10px;
      border-radius: var(--radius-second);
      &:last-of-type {
        margin-bottom: 0;
      }
      &.active {
        background-color: var(--grayscale-20);
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.customer-detail.mt-20 {
  margin-top: 20px;
}
.buy-package {
  padding-bottom: 30px;
  margin: 0 auto;
  &.custom-container.p-0 {
    padding: 0px !important;
  }

  &__content {
    .message {
      &-title {
        margin-bottom: 20px;
        font-weight: 400 !important;
        color: var(--color-primary-black-metallic);
        font-size: 14px !important;
        @media (max-width: 768px) {
          font-size: 12px !important;
        }
      }
    }

    .info {
      display: flex;
      flex-direction: row;
      background: var(--color-primary-warning-text-background);
      padding: 12px;
      margin-bottom: 20px;
      border-radius: var(--radius-second);
      align-items: center;
      flex-basis: 100%;
      @media (max-width: 768px) {
        align-items: flex-start;
      }
      svg {
        flex-shrink: 0;
        margin-right: 5px;
        @media (max-width: 1150px) {
          margin-right: 5px;
        }
      }

      p {
        font-size: 13px;
        color: var(--color-primary-warning-text);
        span {
          font-weight: bold;
        }
      }
    }
    .warn-text {
      font-size: 14px;
      color: var(--color-primary-black-metallic);
      margin-bottom: 20px;
    }
  }

  .tab-content {
    background: var(--grayscale-0);
    border-top: solid 1px var(--grayscale-20);
    padding: 20px;
  }

  .tab-layout {
    .tabs {
      position: relative;
      display: flex;
      justify-content: flex-start !important;
      align-items: center;
      padding-bottom: 0;
      padding-top: 0;
      background: var(--grayscale-0);
      border-bottom: 1px solid var(--color-primary-tint-second);
      height: 56px;
      top: 1px;
      gap: 0px 15px;

      @media (max-width: 768px) {
        height: auto !important;
        gap: 20px;
        padding: 0px 20px;
        overflow-x: scroll;
        padding-left: 12px;
        box-sizing: border-box;
        &::-webkit-scrollbar {
          width: 0px;
          height: 0px;
        }
      }

      h6 {
        font-weight: 400;
        color: var(--color-primary-silver-metallic);
      }

      .tab {
        cursor: pointer;
        flex: 0.33;
        height: 56px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        border-bottom: 2px solid transparent;
        max-width: max-content;
        width: 100%;
        @media (max-width: 768px) {
          max-width: max-content;
          width: auto;
          flex: 0 0 auto;
        }
      }

      .active {
        border-bottom: 3px solid var(--color-primary-green);

        h6 {
          font-weight: bold;
          color: var(--color-primary-green);
        }
      }
    }
  }

  .profAlgoTabs {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    text-align: center;
    gap: 10px;

    @media (max-width: 768px) {
      flex-direction: row;
      overflow: auto;
      &::-webkit-scrollbar {
        height: 0px;
        width: 0px;
      }
    }

    .profAlgoTab {
      padding: 5px;
      border-radius: var(--radius-second);
      cursor: pointer;
      border: 1.5px solid var(--grayscale-110);
      margin-bottom: 20px;
      @media (max-width: 768px) {
        padding: 3.75px 3px;
        box-sizing: border-box;
        min-width: 84px;
      }
      &.active {
        background-color: var(--color-primary-tint-third);
        border: 1.5px solid var(--color-primary-default);
        .name {
          font-weight: bold;
          color: var(--color-primary-default);
        }
      }
      .name {
        margin: 0 10px;
        color: var(--grayscale-60);
        font-size: 16px;
        @media (max-width: 768px) {
          margin: 0 5px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
